import React, {  useState } from 'react';

import PaymentHistory from './PaymentHistory';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
    PAYMENTS
} from '../../../../constants/routes';
import Cards from './Cards'
import { useDispatch } from 'react-redux';

const RegisteredLaouyt = ({ view,cardUser, cardinfo, deleteCard, isPaymentHistory }) => {
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const [deletePop, setDeletePop] = useState(false);
    const [changePop, setchangePop] = useState(false);
    const [cardPopup, setCardPopup] = useState(false);
    const { t, i18n } = useTranslation();
    const Popup = () => {
        return (
            <div className="card-popup-wrapper">
                <div className="card-popup">

                    {
                        deletePop ?
                            <div >
                                <h2>{t(`Delete card`)}</h2>
                                {
                                    cardUser.subscribing_paid > 0 ? 
                                    <p className="delete-paid-card">{t('Are you sure that you want to ')}
                                    <span style={{ color: '#ff355a' }}>{t('delete this card')}</span>?
                                    {t('If you delete your credit card, all of your paid ')}
                                    <span style={{ color: '#36cfff' }}>{t(' subscription  ')}</span> 
                                    {t('plans will be  ')}<span style={{ color: '#ff355a' }}>{t('terminated')}</span>{t(' on their expiration dates.')}</p>

                                        : <p>{t(`Are you sure?`)}</p>
                                }

                                <div className="popup-footer">


                                    <a onClick={() => { setCardPopup(false); setDeletePop(false) }} className="cancel-btn">{t(`Cancel`)}</a>
                                    <Link to={PAYMENTS} className="change-btn">{t(`Change card`)}</Link>

                                    <a onClick={() => { deleteCard(); setCardPopup(false); setDeletePop(false) }} className="change-btn">{t(`Delete`)}</a>
                                </div>
                            </div>
                            :
                            <div className="change-popup">
                                <h2>{t(`Change card`)}</h2>
                                <p>{t(`Are you sure?`)}</p>
                                <div className="popup-footer">

                                    <a onClick={() => { setCardPopup(false); setchangePop(false) }} className="cancel-btn">{t(`Cancel`)}</a>
                                    <Link to={PAYMENTS} className="change-btn">{t(`Change card`)}</Link>
                                </div>
                            </div>
                    }
                </div>
            </div>

        )
    }
    React.useEffect(() => {
    }, []);

    return (
        <div className={'registered-container unregister-container'} >
            {cardPopup && Popup()}
            {
                view ?
                    <>

                        <div>
                            <div className="unregister-header"><h2>{t(`Your card`)}</h2></div>
                            <div className="card-container">
                                <div className="card-container--header d-flex">
                                    <div className="card-type d-flex">
                                        {cardinfo.map((item,indx) => item.cardType &&
                                            <div key={indx} className="visa--icon" style={{ paddingRight: '8px', marginTop: '-2px' }}>
                                                <Cards cardName={item.cardType} />
                                            </div>
                                        )
                                        }
                                        <div className='card--type'>

                                            {cardinfo.map(item => item.cardType)}
                                        </div>
                                    </div>
                                    <p className="card-number  d-flex"><span>********</span>{cardinfo.map(item => item.cardLastFourDigits)}</p>
                                </div>
                                <div className="card-container--body">
                                    <div className="card-exp-date">{t(`Exp`)} {cardinfo.map(item => item.expirationMonth)} / {cardinfo.map(item => item.expirationYear.toString().substr(-2))}</div>

                                </div>
                                <div className="card-container--footer d-flex">
                                    <a onClick={() => { setchangePop(true); setCardPopup(true) }}>{t(`Change card`)}</a>
                                    <a onClick={() => { setDeletePop(true); setCardPopup(true) }}>{t(`Delete`)}</a>
                                </div>
                            </div>
                            <div className="unregister-card-content">
                                <p style={{ height: '0', padding: '0' }}></p>
                                <p className="payment-text-complaint">{t(`PAYMENT_COMPLIANT`)}</p>
                                <p className="payment-text-charges">{t(`CHARGES_APPEAR`)}</p>

                            </div>
                        </div>
                    </>


                    :
                    <>

                        <div>
                            <div className="unregister-header"><h2>{t('Payments')}</h2></div>
                            <div className="unregister-card-content">
                                {isPaymentHistory ? isPaymentHistory.slice().reverse().map((item,indx) => <PaymentHistory key={indx} isPaymentHistory={item} />) : <p>{t(`You haven’t made any payments yet`)}</p>}

                                <p className="payment-text-complaint">{t(`PAYMENT_COMPLIANT`)}</p>
                                <p className="payment-text-charges">{t(`CHARGES_APPEAR`)}</p>


                            </div>
                        </div>

                    </>
            }
        </div>
    );
};

export default RegisteredLaouyt;
